import * as angular from "angular";
import {IController} from "angular";

export class PlanningRoutesViewSettingsPanelTemplateComponent implements IController {

  settings: any;
  panelRef: any;

  public settingsCopy: any;
  public enabledSections: { columns: boolean, dynamicColumns: boolean } = {
    columns: false,
    dynamicColumns: false
  };

  $onInit() {
    this.settingsCopy = angular.copy(this.settings);
  }

  onColumnsChange(columns) {
    this.settingsCopy.columns = columns;
  }


  onToggleIsOpenColumns(isOpen) {
    this.enabledSections.columns = !this.enabledSections.columns;
  }

  onToggleIsOpenDynamicColumns(isOpen) {
    this.enabledSections.dynamicColumns = !this.enabledSections.dynamicColumns;
  }

  onSubmit() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Submit', this.settingsCopy);
  }

  onReset() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Reset');
  }

  onCancel() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Cancel');
  }

}

angular
  .module('bringoz.admin.lean-planning')
  .component('planningRoutesSettingsPanelTemplate', {
    bindings: {
      settings: '<',
      panelRef: '<'
    },
    template: require('./planning-routes-view-settings-panel-template.html').default,
    controller: PlanningRoutesViewSettingsPanelTemplateComponent
  });
